export default __webpack_public_path__ + "static/media/LAS0200.34I-30391_-17572_0.28fb78c3.jpg";